import React from 'react'
import styled from 'styled-components'

const darkblue = `rgba(23, 104, 172, 1)`
const lightblue = `rgba(6, 190, 225, 1)`
const pink = `#FF6B98`

const StyledQuote = styled.div`
  padding-bottom: 80px;
  width: 100%;
  position: relative;
  &:before {
    content: '“';
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    top: 0;
    left: -15px;
    @media (min-width: 768px) {
      font-size: 50px;
      left: -30px;
      top: -10px;
    }
  }
`
const Text = styled.blockquote`
  line-height: 1.3;
  font-size: 28px;
  @media (min-width: 768px) {
    font-size: 36px;
  }
  padding-bottom: 10px;
  position: relative;
  &:before {
    content: '';
    width: 80px;
    height: 2px;
    background: ${darkblue};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -20px;
  }
`

const Name = styled.a`
  color: ${lightblue};
  font-weight: 400;
  font-size: 24px;
  float: right;
  font-family: 'Raleway';
  border-bottom: 4px solid transparent;
  transition: all 350ms ease;
  &:hover {
    border-bottom: 4px solid ${pink};
  }
`

const Quote = ({ text, name, link }) => (
  <StyledQuote>
    <Text>{text}”</Text>
    <cite>
      <Name href={link}>{name}</Name>
    </cite>
  </StyledQuote>
)

export default Quote



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Quote.js